import { render, staticRenderFns } from "./videoSelectorCard.vue?vue&type=template&id=37c1126d&scoped=true"
import script from "./videoSelectorCard.vue?vue&type=script&lang=js"
export * from "./videoSelectorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c1126d",
  null
  
)

export default component.exports